import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/manage/$companySlug/projects/$projectId/')({
  beforeLoad: ({ params }) => {
    // TanStack Router uses thrown redirect descriptors for route control flow.
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ params, to: '/manage/$companySlug/projects/$projectId/overview' });
  },
});
